import React from 'react';
import { RefreshCw } from 'lucide-react';

export function UpdateNotification() {
  const handleUpdate = async () => {
    try {
      // Unregister any existing service workers
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          await registration.unregister();
        }
      }

      // Clear all caches
      if ('caches' in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(
          cacheKeys.map(key => caches.delete(key))
        );
      }

      // Clear localStorage
      localStorage.clear();

      // Clear sessionStorage
      sessionStorage.clear();

      // Force reload the page
      window.location.reload();
    } catch (error) {
      console.error('Error updating application:', error);
      // Fallback to simple reload if clearing caches fails
      window.location.reload();
    }
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 flex justify-center z-50">
      <div className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2">
        <span>A new version is available!</span>
        <button
          onClick={handleUpdate}
          className="bg-white text-blue-500 px-3 py-1 rounded flex items-center gap-1 hover:bg-blue-50 transition-colors"
        >
          <RefreshCw className="w-4 h-4" />
          Update now
        </button>
      </div>
    </div>
  );
}